import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';

import Login from './pages/Login';
import SuperAdminDashboard from './pages/superadmin/Dashboard';
import OwnerDashboard from './pages/owner/Dashboard';
import OwnerCategories from './pages/owner/Categories';
import OwnerMenuItems from './pages/owner/MenuItems';
import OwnerQRCode from './pages/owner/QRCode';
import OwnerProfile from './pages/owner/Profile';
import CustomerMenu from './pages/customer/Menu';

function PrivateRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="page-loader"><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" />;
  if (role && user.role !== role && !(role === 'owner' && user.role === 'superadmin')) {
    return <Navigate to="/login" />;
  }
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={
        user ? <Navigate to={user.role === 'superadmin' ? '/superadmin' : '/owner'} /> : <Login />
      } />
      <Route path="/superadmin" element={
        <PrivateRoute role="superadmin"><SuperAdminDashboard /></PrivateRoute>
      } />
      <Route path="/owner" element={
        <PrivateRoute role="owner"><OwnerDashboard /></PrivateRoute>
      } />
      <Route path="/owner/categories" element={
        <PrivateRoute role="owner"><OwnerCategories /></PrivateRoute>
      } />
      <Route path="/owner/menu" element={
        <PrivateRoute role="owner"><OwnerMenuItems /></PrivateRoute>
      } />
      <Route path="/owner/qrcode" element={
        <PrivateRoute role="owner"><OwnerQRCode /></PrivateRoute>
      } />
      <Route path="/owner/profile" element={
        <PrivateRoute role="owner"><OwnerProfile /></PrivateRoute>
      } />
      <Route path="/menu/:restaurantId" element={<CustomerMenu />} />
      <Route path="/" element={<Navigate to="/login" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: { fontFamily: 'Poppins, sans-serif', fontSize: '14px' },
            success: { style: { background: '#27AE60', color: 'white' } },
            error: { style: { background: '#E74C3C', color: 'white' } },
          }}
        />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
